import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';

const key = (recommendationId, source, type) =>
  `${recommendationId}|${source}|${type}`;

/**
 * Tracks published source/type groups that have been edited but not confirmed.
 *
 * The backend keeps no such flag — `confirmInstrumentRecommendationChanges` is
 * the only acknowledgement available — so this is a best-effort local record.
 * It is persisted per browser, which means it will not follow an operator to
 * another device.
 */
export const useDirtyRecommendationStore = create(
  persist(
    (set, get) => ({
      dirty: {},

      markDirty: (recommendationId, source, type) =>
        set(state => ({
          dirty: {...state.dirty, [key(recommendationId, source, type)]: true},
        })),

      clearDirty: (recommendationId, source, type) =>
        set(state => {
          const next = {...state.dirty};
          delete next[key(recommendationId, source, type)];
          return {dirty: next};
        }),

      isDirty: (recommendationId, source, type) =>
        Boolean(get().dirty[key(recommendationId, source, type)]),
    }),
    {
      name: 'instrument-recommendation-unconfirmed-changes',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export default useDirtyRecommendationStore;
